import { lazy } from "react";
import { Route } from "react-router-dom";

import { RequireAdmin } from "./guards";
import { ROUTE_PATHS } from "./paths";

const AdminDashboardPage = lazy(() => import("../../features/admin/dashboard/pages/AdminDashboardPage"));
const AdminProductsPage = lazy(() => import("../../features/admin/products/pages/AdminProductsPage"));
const AdminProductUploadPage = lazy(() => import("../../features/admin/products/pages/AdminProductUploadPage"));
const AdminOrdersPage = lazy(() => import("../../features/admin/orders/pages/AdminOrdersPage"));
const AdminOrderDetailsPage = lazy(() => import("../../features/admin/orders/pages/AdminOrderDetailsPage"));
const AdminCategoriesPage = lazy(() => import("../../features/admin/categories/pages/AdminCategoriesPage"));
const AdminVouchersPage = lazy(() => import("../../features/admin/vouchers/pages/AdminVouchersPage"));

export const adminRoutes = (
  <>
    <Route
      path={ROUTE_PATHS.adminRoot}
      element={
        <RequireAdmin>
          <AdminDashboardPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminProducts}
      element={
        <RequireAdmin>
          <AdminProductsPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminProductNew}
      element={
        <RequireAdmin>
          <AdminProductUploadPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminOrders}
      element={
        <RequireAdmin>
          <AdminOrdersPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminOrderDetails}
      element={
        <RequireAdmin>
          <AdminOrderDetailsPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminCategories}
      element={
        <RequireAdmin>
          <AdminCategoriesPage />
        </RequireAdmin>
      }
    />
    <Route
      path={ROUTE_PATHS.adminVouchers}
      element={
        <RequireAdmin>
          <AdminVouchersPage />
        </RequireAdmin>
      }
    />
  </>
);






